import React from 'react';

import '../icon-component.scss';

const CloseComponent = () => (
  <svg className="icon-component" viewBox="0 0 14 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-17.000000, -17.000000)">
        <path d="M24.707,24 L30.353,18.354 C30.549,18.158 30.549,17.842 30.353,17.646 C30.158,17.451 29.842,17.451 29.646,17.646 L24,23.293 L18.353,17.646 C18.158,17.451 17.842,17.451 17.646,17.646 C17.451,17.842 17.451,18.158 17.646,18.354 L23.293,24 L17.646,29.646 C17.451,29.842 17.451,30.158 17.646,30.354 C17.744,30.451 17.872,30.5 18,30.5 C18.128,30.5 18.256,30.451 18.353,30.354 L24,24.707 L29.646,30.354 C29.744,30.451 29.872,30.5 30,30.5 C30.128,30.5 30.256,30.451 30.353,30.354 C30.549,30.158 30.549,29.842 30.353,29.646 L24.707,24 L24.707,24 Z" />
      </g>
    </g>
  </svg>
);

CloseComponent.displayName = 'CloseIcon';

export default CloseComponent;
